"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyDynamicModifiers = applyDynamicModifiers;

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isDynamicResponsiveModifiersProp(val) {
  return (0, _isObject.default)(val) && !Array.isArray(val);
}
/**
 * Selects the correct modifier prop value based on the size.
 *
 * @param {DynamicModifiersProp<any, typeof sizes>} modifierPropValue
 * @param {keyof typeof sizes} size
 * @returns {(string | number | undefined)}
 */


function getResponsiveModifierPropValue( // eslint-disable-next-line @typescript-eslint/no-explicit-any
modifierPropValue, size) {
  return Object.keys(modifierPropValue).includes(size) ? modifierPropValue[size] : modifierPropValue._;
}
/**
 * Using an API similar to styled-components-modifiers, this allows either pass through CSS
 * values or a "transformer" function to be applied at runtime.
 *
 * @export
 * @param {string} modifierPropName The prop to be used on the React component when rendered.
 * @param {(string | InterpolationFunction<ComponentProps> | undefined)} cssProp If a string, the modifier
 * prop value will be will be used to create pass through css. If a function, the modifier prop
 * value will be passed through to the function for building a transform.
 * @returns {InterpolationFunction<ComponentProps>}
 */


function applyDynamicModifiers(modifierPropName, cssProp) {
  return function (props) {
    var modifierPropValue = props[modifierPropName];

    if ((0, _isFunction.default)(cssProp)) {
      if (isDynamicResponsiveModifiersProp(modifierPropValue)) {
        var responsiveModifierPropValue = getResponsiveModifierPropValue(modifierPropValue, props.size);
        return responsiveModifierPropValue !== undefined ? cssProp(_objectSpread({}, props, _defineProperty({}, modifierPropName, responsiveModifierPropValue))) : '';
      }

      return modifierPropValue !== undefined ? cssProp(_objectSpread({}, props, _defineProperty({}, modifierPropName, modifierPropValue))) : '';
    }

    var prop = cssProp || modifierPropName;

    if (isDynamicResponsiveModifiersProp(modifierPropValue)) {
      var _responsiveModifierPropValue = getResponsiveModifierPropValue(modifierPropValue, props.size);

      return _responsiveModifierPropValue ? "".concat(prop, ": ").concat(_responsiveModifierPropValue, ";") : '';
    }

    return modifierPropValue !== undefined ? "".concat(prop, ": ").concat(modifierPropValue, ";") : '';
  };
}